import type { ComponentType, SVGProps } from "react";
import type { BUITheme } from "@blofin/blofin-ui";
import type { MenuProps } from "../../../Header/types";
import Wow2026LightIcon from "../assets/header/wow2026-light.svg?react";
import Wow2026DarkIcon from "../assets/header/wow2026-dark.svg?react";

/**
 * 活动入口配置：
 * 所有"钉在 nav 末尾、不参与收起"的活动入口图，都集中在此声明。
 *
 * - 替换活动：改下面数组里的 icon/url/className 即可
 * - 下线活动：把对应项删掉，或临时把 entries 改成 []
 * - 多活动并存：往 entries 里追加一项
 *
 * 业务侧不需要改 Nav/useNav/useOverflowNav 这三个底层文件。
 */

export interface PinnedActivityCtx {
  theme: BUITheme | undefined;
  localeLink: string;
  isUk: boolean;
  isDemoTrading: boolean;
}

interface PinnedActivityEntry {
  /** 活动唯一 key，仅作 React key 与可选埋点用 */
  key: string;
  /** 是否显示。返回 false 则不渲染该项 */
  visible: (ctx: PinnedActivityCtx) => boolean;
  /** 跳转地址。可基于 ctx 拼接 localeLink 等 */
  href: (ctx: PinnedActivityCtx) => string;
  /** light / dark 两套图。SVG 用 ?react 导入 */
  icons: {
    light: ComponentType<SVGProps<SVGSVGElement>>;
    dark: ComponentType<SVGProps<SVGSVGElement>>;
  };
  /** 图片样式（尺寸、外边距等） */
  iconClassName?: string;
}

const entries: PinnedActivityEntry[] = [
  {
    key: "wow2026",
    visible: ({ isUk, isDemoTrading }) => !isUk && !isDemoTrading,
    href: ({ localeLink }) => `/activity${localeLink}/wow2026`,
    icons: { light: Wow2026LightIcon, dark: Wow2026DarkIcon },
    iconClassName: "ml-[-8px] mr-[-8px] w-[120px] h-[42px]" //rtl-ignore
  }
];

/** 把活动配置展开为 nav 框架认识的 MenuProps[]，theme 决定取哪套图 */
export const buildPinnedTail = (ctx: PinnedActivityCtx): MenuProps[] => {
  return entries
    .filter((entry) => entry.visible(ctx))
    .map<MenuProps>((entry) => {
      const Icon = ctx.theme === "light" ? entry.icons.light : entry.icons.dark;
      return {
        noH5: true,
        type: "img",
        // pinned 项不显示文本，label 仅用于点击埋点 tab_name；
        // MenuProps.label 是 MessagesType 联合，活动入口统一归类为 "activity"。
        label: "activity",
        url: entry.href(ctx),
        isSupportDemoTrading: false,
        src: <Icon className={entry.iconClassName} />
      };
    });
};
